import React from 'react';
import '../ReportsPageTranslate';
import { useDispatch, useSelector } from 'react-redux';
import { loadEmailList, reportsPageModule } from '../ReportsPageDucks';
import useTableFilter from '../../../components/TableFilter/useTableFilter';
import StaticTablePagination from '../../../_ui/Table/StaticTablePaginated';
import { reportsSettingEmailColumn } from './ReportsSettingEmailColumn';
import { useTranslation } from 'react-i18next';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import Paper from '@material-ui/core/Paper';
import paths from '../../../_helpers/paths';
import useSimpleModal from '../../../components/_hooks/useSimpleModal';
import ReportsSettingDeleteEmailModal from './ReportsSettingDeleteEmailModal';
import Button from '../../../_ui/Button/Button';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import ReportsSettingAddEmailModal from './ReportsSettingAddEmailModal';

const ReportsSettingEmailPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const emailList = useSelector(state => state[reportsPageModule].emailList);
  const loadingTable = useSelector(state => state[reportsPageModule].loading);
  const { nextPage,reloadPage } = useTableFilter(filter => dispatch(loadEmailList({ filter })));
  const deleteEmailModal = useSimpleModal();
  const addEmailModal = useSimpleModal();


  const breadCrumbItems = [
    { name: t('breadcrumbs_home'), href: '/' },
    { name: t('breadcrumbs_reportsSettingEmail'), href: paths.reportsSettingEmail }
  ];
  return (
    <>
      <BreadCrumbs items={breadCrumbItems} />
      <Paper className="pb3 pt1 px3">
        <div className="flex justify-between items-center">
          <h3>{t('reportsPage_settingEmail')}</h3>
          <Button
            icon={<MailOutlineIcon style={{ marginRight: 5 }} />}
            text={t('reportsPage_addEmail')}
            onClick={() => addEmailModal.open(true)}
          />
        </div>
        <div className="mt1">
          <StaticTablePagination
            sortable={false}
            loading={loadingTable}
            columns={reportsSettingEmailColumn({ t, deleteEmailModal })}
            totalElements={emailList.totalElements}
            data={emailList.content}
            onClickLoadMore={() => nextPage()}
          />
        </div>
      </Paper>
      {deleteEmailModal.isOpen && <ReportsSettingDeleteEmailModal {...deleteEmailModal} reloadPage={reloadPage} />}
      {addEmailModal.isOpen && <ReportsSettingAddEmailModal {...addEmailModal} reloadPage={reloadPage} />}

    </>
  );
};

export default ReportsSettingEmailPage;
